import React, { useEffect } from 'react';
import { Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Routes, Route, Switch } from 'react-router-dom';
import { IRootReducer } from 'store/reducers';
import { loadUser } from 'store/user/user.action';
import { IUserState } from 'store/user/user.interface';
import { useLocalStorage } from 'utils';
import MasterPage from '../components/MasterPage';
import Login from './Login';
import RoutesList from './RoutesList';
import PageNotFound from './Error/PageNotFound';
import { useCompany } from 'store/models';
import { getStorage } from 'utils/useLocalStorage';
import { ICompanyState } from 'store/company/company.interface';

function App() {
  const [ token ] = useLocalStorage("token",null);
  const user = useSelector<IRootReducer,IUserState>(state => state.user);
  const company = useCompany();
  const dispatch = useDispatch();  

  useEffect(()=>{
    if(token){
      dispatch(loadUser());
    }
  },[token, dispatch])

  useEffect(()=>{
    let body = document.body;
    let load = document.getElementById('load-root');
    
    if(user && user.id !== 0 && body && company && company.id === 0){
      if (user.language) {
        localStorage.setItem('i18nextLng', user.language);
      }

      if(user.company){
        company.set({...user.company, connected:true, cleanable:false});
      } else if(getStorage("company_access")){
        let aux = getStorage<ICompanyState>("company_access");
        if(aux){
          company.set(aux);
        }
      }
      body.className = user.theme ?? "light";
      if(load) load.classList.add("removing");
      setTimeout(() =>{
        if(load){
          load.style.display = "none";
        }
      },1500);
    } else if(!token){
      setTimeout(()=>{
        if(load)load.classList.add("removing");
        body.className = "";
        setTimeout(() =>{
          if(load) load.style.display = "none";
        },1500);
      },1500);
    }
  },[user, token, company]);

  if(!token){
    return (
      <Routes>
        <Switch>
          <Route exact path="/"><Login/></Route>
          <Route path="/"><Redirect to="/" /></Route>
        </Switch>
      </Routes>
    );
  }

  if(token && user.userLoad && !user.errorRequest){
    return <></>;
  }

  return (   
    <Routes>
      <MasterPage>
        <Switch>
          {RoutesList.filter(item=>{
            if(item.permission) return user.permissions.indexOf(item.permission) !== -1;
            if(item.permission_by_user) return user.email === item.permission_by_user;
            return true;
          }).map((a,k)=>{
            let Page = a.page;
            return <Route exact key={k} path={a.path} component={Page}/>;
          })}
          <Route path="/" component={PageNotFound}/>
        </Switch>
      </MasterPage>
    </Routes>
  );
}

export default App;
